function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import { css } from '@emotion/react';

var _ref = process.env.NODE_ENV === "production" ? {
  name: "19waxfi",
  styles: ".__flex{display:flex;justify-content:space-between;}.image-box{padding:0 0.5em;}"
} : {
  name: "19waxfi",
  styles: ".__flex{display:flex;justify-content:space-between;}.image-box{padding:0 0.5em;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9vcHQvYnVpbGQvcmVwby9ub2RlX21vZHVsZXMvQHN3cC9jb21wb25lbnRzL2xpYi9Db2x1bW4vbGF5b3V0MjcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQzRCIiwiZmlsZSI6Ii9vcHQvYnVpbGQvcmVwby9ub2RlX21vZHVsZXMvQHN3cC9jb21wb25lbnRzL2xpYi9Db2x1bW4vbGF5b3V0MjcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5leHBvcnQgZGVmYXVsdCAodGhlbWUgPT4gY3NzYFxuICAuX19mbGV4IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgfVxuXG4gIC5pbWFnZS1ib3gge1xuICAgIHBhZGRpbmc6IDAgMC41ZW07XG4gIH1cbmApOyJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export default (function (theme) {
  return _ref;
});